import { useCallback } from 'react';

import ToastComponent, { IToastType } from '../components/Toast/ToastComponent';
import { useCancelEbookSubmissionMutation } from '../core/graphql/operation-hooks';

const useMutationCancelEbookSubmission = () => {
  const [mutate, { loading }] = useCancelEbookSubmissionMutation();

  const cancelEbookSubmission = useCallback(
    async (ebookSubmissionId: string) => {
      try {
        const res = await mutate({
          variables: { ebookSubmissionId },
          refetchQueries: ['EbookSubmissions', 'EbookSubmission'],
        });
        if (res.data?.cancelEbookSubmission?.success) {
          return { success: true };
        } else {
          ToastComponent({ label: 'Cancel failed.', type: IToastType.ERROR });
          return { success: false };
        }
      } catch (err) {
        ToastComponent({ label: 'An error occurred.', type: IToastType.ERROR });
        return { success: false };
      }
    },
    [mutate],
  );

  return { cancelEbookSubmission, isCancellingEbookSubmission: loading };
};

export default useMutationCancelEbookSubmission;
